import React from "react";


export default function HomeScreen() {
  return (
    <div className="text-center   m-0 p-0 w-full " id="top">
      {/* mobile minmaliste */}

      {/*  <img src="/img/kerenHead.JPG" className='hidden  head md:block absolute top-0 w-full p-0 object-cover md:pt-0 -z-10 ' alt="" />
  <img src="/img/kerenJauneDet.jpg" className='block headSm md:hidden absolute  object-cover min-h-full top-0 w-full pt-18 -z-10 ' alt="" /> */}
      <section className="pt-28 headerBgImg  p-4 ">
      

      <h1 id="Tit" className="md:mt-20 center  text-white   font-bold mb-8  ">
          Danses latines et de salon
          <br /> à Neuvilly
        </h1>
        {/* <img src="/img/logo1.png" alt="" className='m-auto hidden md:block w-56 '/> */}
      
        <br />

      
        <div
          id="head"
          className=" md:mb-16 space-y-8  text-xl text-white font-medium md:w-1/2 md:mt-56 lg:mt-64 m-auto "
        >
          <div className=" space-y-8   p-8   rounded md:p-4">
         

            <div className="md:hidden  flex flex-wrap md:flex md:flex-wrap md:fixed md:m-start md:left-0 md:bottom-0 w-6/6 justify-center bg-black bg-opacity-50 backdrop-blur-sm items-center shad m-auto md:space-x-8  space-x-4 icones ">
              <div className="flex-col flex-wrap items-center md:justify-center ">
                <div className=" rounded p-4 md:p-2  ">
                  <a
                    href="https://www.facebook.com/kerenor.almogi"
                    target="_blank"
                    
                   
                  >
                    <img
                      src="../../img/facebook.svg"
                      alt=""
                      className=" m-auto rounded  "
                    />
                  </a>
                </div>
                <p className="text-white  text-xl">Facebook</p>
              </div>

              <div className="flex-col items-center justify-center">
                <div className="   rounded  p-4 md:p-2">
                  <a href="https://www.instagram.com/kerenor.almogi">
                    <img
                      src="../../img/insta.svg"
                      target="_blank"
                      alt=""
                      className="rounded m-auto"
                    />
                  </a>
                </div>
                <p className="text-white ">Instagram</p>
              </div>

              <div className="flex-col items-center justify-center ">
                <div className=" rounded  p-4 md:p-2">
                  <a href="https://www.youtube.com/@keren-oralmogi1858">
                    <img
                      src="../../img/youtube111.svg"
                      target="_blank"
                      alt=""
                      className=" rounded m-auto"
                    />
                  </a>
                </div>
                <p className="text-white ">Youtube</p>
              </div>

              <div className="flex-col items-center justibel hommefy-center ">
                <div className=" rounded  p-4 md:p-2">
                  <a href="https://wa.me/33603755840">
                    <img
                      src="../../img/WA.svg"
                      target="_blank"
                      alt=""
                      className=" rounded m-auto"
                    />
                  </a>
                </div>
                <p className="text-white ">What's App</p>
              </div>

              <div className="flex-col items-center justify-center ">
                <div className=" rounded  p-4 md:p-2">
                  <a href="https://maps.app.goo.gl/E1jXB7edZkAhop6p8">
                    <img
                      src="../../img/maps.svg"
                      target="_blank"
                      alt=""
                      className=" rounded m-auto"
                    />
                  </a>
                </div>
                <p className="text-white ">Maps</p>
              </div>

              <div className="flex-col items-center justify-center ">
                <div className=" rounded p-4 md:p-2">
                  <a href="tel:+33603755840">
                    <img
                      src="../../img/tel.svg"
                      target="_blank"
                      alt=""
                      className=" rounded m-auto"
                    />
                  </a>
                </div>
                <p className="text-white ">Téléphone</p>
              </div>

              <div className="flex-col items-center justify-center ">
                <div className=" rounded  p-4 md:p-2">
                  <a href="mailto:danse.de.salon.neuvilly@gmail.com">
                    <img
                      src="../../img/mail.svg"
                      target="_blank"
                      alt=""
                      className=" rounded m-auto"
                    />
                  </a>
                </div>
                <p className="text-white ">Mail</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="my-16  md:mt-46 ">
        <h1 className="text-center my-8">Bienvenue chez Leading Danse !</h1>

        <h2 className="text-center text-xl text-white font-medium my-8 " id="h2head">
          Venez découvrir les danses de salon Avec Keren-Or, professeur certifiée par l'I.T.D.A.
          <br />
          <br />
          Tous les Lundis soirs.
        </h2>

        <div className="flex flex-wrap justify-center space-x-8 space-y-4 items-start ">
          <img
            src="../../img/kerenSec1.JPG"
            className="lg:w-1/5 md:1/6 w-1/2 rounded shadow "
            alt=""
          />

          <p className="md:w-1/2 lg:w-1/4 text-justify text-xl pt-0 mt-0 pr-8">
            Envie de découvrir les danses latines et standards, de préparer une
            chorégraphie unique pour un événement (ouverture de bal, enterrement
            de vie de jeune fille) ou simplement de vous sentir à l'aise en
            soirée ? <br /> <br />
            Que vous soyez débutant ou souhaitiez perfectionner vos pas, je vous
            accompagne avec une pédagogie simple, bienveillante et efficace,
            basée sur la méthode IDTA de Londres. <br />
            <br />
            Mes cours s'adressent à tous les niveaux, et peuvent aussi être
            adaptés à des entreprises pour renforcer la cohésion d'équipe à
            travers la danse et le team building. <br /> Ensemble, nous
            travaillerons des aspects essentiels comme le guidage, la posture et
            le rythme, tout en favorisant la créativité personnelle. <br />
            <br />
            Suivez-moi sur Instagram, YouTube et Facebook pour découvrir mes
            chorégraphies et rejoignez-moi pour un apprentissage dans la bonne
            humeur !
          </p>
        </div>
      </section>

      <section className="space-y-4  dixRaisons md:space-y-8 py-16">
        <h1 className="  pt-4 md:text-5xl font-bold text-white  mb-12">
          5 raisons de découvrir la danse de salon
        </h1>
        <div className="text-zinc-800"></div>

        <div className="z-index-10 ">
          <div className="flex flex-wrap space-y-8 md:space-x-8 md:space-y-16 justify-center pw items-start  ">
            <div></div>

            <div className="container flex-col  shado text-white  p-2 w-5/6 md:w-2/6  lg:w-1/6">
              <h1 className="">Posture</h1>
              <hr className="my-2" />
              <div className="content-wrapper">
                <p className="hidden-content pw py-2">
                  <br /> 
                  <strong className="font-bold text-xl drop-shadow-sm">
                    La danse
                  </strong>{" "}
                  joue un rôle crucial dans le développement d'une{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    bonne posture et de la souplesse
                  </strong>
                  . En pratiquant régulièrement, on{" "}
                  <strong className="font-bold text-xl drop-shadow-sm">
                    renforce
                  </strong>{" "}
                  sa tenue et on apprend à mieux positionner son corps, ce qui
                  aide à maintenir une{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    silhouette droite et harmonieuse
                  </strong>
                  .
                </p>{" "}
              </div>
            </div>

            <div className="container  flex-col  shado  text-white  p-2 w-5/6 md:w-2/6 lg:w-1/6">
              <h1 className="">Santé</h1>
              <hr className="my-2" />
              <div className="">
                <p className="hidden-content pw ">
                  <br /> 
                  En plus d'être une{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    {" "}
                    activité physique agréable
                  </strong>
                  , la danse améliore la santé générale. Elle permet de{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    rester actif
                  </strong>
                  , de{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    renforcer
                  </strong>{" "}
                  les muscles et d'
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    augmenter
                  </strong>{" "}
                  l'endurance, tout en procurant un sentiment de{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    plaisir
                  </strong>{" "}
                  et de{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    satisfaction
                  </strong>
                  , ce qui la rend plus motivante qu'un entraînement
                  traditionnel.
                </p>{" "}
              </div>
            </div>

            <div className="container  flex-col  shado text-white  p-2 w-5/6 md:w-2/6 lg:w-1/6">
              <h1 className="">Social</h1>
              <hr className="my-2" />
              <div className="content-wrapper">
                <p className=" pw">
                  <br /> 
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    Danser
                  </strong>{" "}
                  n'est pas seulement une activité individuelle, c'est aussi un
                  excellent moyen de créer des{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    liens
                  </strong>
                  . La pratique en{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    groupe
                  </strong>{" "}
                  permet de renforcer l'environnement social, de rencontrer de
                  nouvelles personnes et de se sentir plus à l'aise dans les
                  interactions sociales.
                </p>{" "}
              </div>
            </div>

            <div className="container  flex-col  shado text-white p-4 w-5/6 md:w-2/6 lg:w-1/6">
              <h1 className="">Bien-être</h1>
              <hr className="my-2" />
              <div className="content-wrapper">
                <p className=" pw">
                  <br /> 
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    La danse
                  </strong>{" "}
                  est un excellent moyen de se{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    détendre
                  </strong>{" "}
                  et de réduire le stress. En se concentrant sur les mouvements
                  et la musique, les tensions corporelles diminuent, ce qui
                  contribue à une meilleure{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    sérénité
                  </strong>{" "}
                  et à une{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    confiance
                  </strong>{" "}
                  accrue dans ses capacités physiques et mentales.
                </p>{" "}
              </div>
            </div>

            <div className="container  flex-col  shado  text-white  p-4 w-5/6 md:w-2/6 lg:w-1/6">
              <h1 className="">Joie</h1>
              <hr className="my-2" />
              <div className="content-wrapper">
                <p className=" pw">
                  <br /> 
                  <strong className="font-bold text-xl drop-shadow-sm">
                    Danser
                  </strong>{" "}
                  est synonyme de{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    joie
                  </strong>{" "}
                  et de{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    bonheur
                  </strong>
                  . Que ce soit lors d'une{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    fête
                  </strong>{" "}
                  ou d'un événement social, la danse procure une sensation de
                  bien-être immédiat, fait{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    sourire
                  </strong>{" "}
                  et génère une{" "}
                  <strong className=" font-bold text-xl drop-shadow-sm">
                    énergie positive
                  </strong>{" "}
                  qui se transmet aux autres.
                </p>{" "}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="my-12 w-5/6 m-auto  text-zinc-600 font-bold md:text-3xl">
        <h1 className=" center md:text-5xl text-teal-800 font-bold mb-8 ">
          Nos chorégraphies
        </h1>
        <br />
        <br />
        <h2 className="">Les danses standards</h2>

        <div className=" m-auto mb-28 flex flex-wrap justify-center align-items md:space-x-8 space-y-16 lg:space-x-8 m-auto">
          <div className="hidden"></div>
          <div className="cardTango w-full  w-5/6 md:w-2/6 lg:w-1/6  flex-col shado rounded ">
            <div className="space-y-4 ">
              <h3 className=" bg-black bg-opacity-50   mt-40  text-xl    py-4">
                Tango
              </h3>
            </div>
          </div>

          <div className="cardQuick w-full w-5/6 md:w-2/6 lg:w-1/6 flex-col shado rounded ">
            <div className="space-y-4 ">
              <h3 className="  bg-black bg-opacity-70  mt-40 text-xl   py-4 ">
                Quick Step
              </h3>
            </div>
          </div>

          <div className="cardValseLente w-full w-5/6 md:w-2/6 lg:w-1/6 flex-col shado rounded ">
            <div className="space-y-4 ">
              <h3 className="  bg-black bg-opacity-70  mt-40  text-xl    py-4 ">
                Valse lente
              </h3>
            </div>
          </div>

          <div className="cardValseVienoise w-full   w-5/6 md:w-2/6 lg:w-1/6 flex-col shado rounded ">
            <div className="space-y-4 ">
              <h3 className=" bg-black bg-opacity-70  mt-40 text-xl   py-4">
                Valse Vienoise
              </h3>
            </div>
          </div>

          <div className="cardSlowfox w-full w-5/6 md:w-2/6 lg:w-1/6 flex-col shado  rounded ">
            <div className="space-y-4 ">
              <h3 className="  bg-black bg-opacity-70 mt-40 text-xl   py-4 ">
                Slowfox
              </h3>
            </div>
          </div>
        </div>

        <h2>Les danses latines</h2>
        <div className="flex flex-wrap justify-center align-items space-y-16 md:space-x-8 lg:space-x-8 m-auto">
          <div></div>
          <div className="cardSamba w-full w-5/6 md:w-2/6 lg:w-1/6 flex-col shado  rounded ">
            <div className="space-y-4 ">
              <h3 className="  bg-black bg-opacity-70 mt-40 text-xl   py-4">
                Samba
              </h3>
            </div>
          </div>

          <div className="cardDoblo w-full w-5/6 md:w-2/6 lg:w-1/6 flex-col shado  rounded ">
            <div className="space-y-4 ">
              <h3 className="  bg-black bg-opacity-70 mt-40 text-xl   py-4">
                Paso-Doble
              </h3>
            </div>
          </div>

          <div className="cardRumba w-full w-5/6 md:w-2/6 lg:w-1/6 flex-col shado  rounded ">
            <div className="space-y-4 ">
              <h3 className="  bg-black bg-opacity-70 mt-40 text-xl   py-4 ">
                Rumba
              </h3>
            </div>
          </div>

          <div className="cardChaChaCha w-full w-5/6 md:w-2/6 lg:w-1/6 flex-col shado rounded ">
            <div className="space-y-4 ">
              <h3 className="  bg-black bg-opacity-70 mt-40 text-xl   py-4 ">
                Cha Cha Cha
              </h3>
            </div>
          </div>

          <div className="cardJive w-full w-5/6 md:w-2/6 lg:w-1/6 flex-col shado  rounded ">
            <div className="space-y-4 ">
              <h3 className="  bg-black bg-opacity-70 mt-40 text-xl   py-4">
                Jive
              </h3>
            </div>
          </div>
        </div>
       
      </section>

      <section className=" bg shado py-28 px-2 md:px-8 text-white font-bold md:text-3xl ">
        <h1 className="text-white ">KEREN-OR,</h1>
        <p className="text-2xl pw">
          vous invite à découvrir les techniques de danse, grâce à la méthode{" "}
          <strong className="text-3xl  font-bolder"> I.D.T.A.</strong> <br />{" "}
          <br /> Apprennez de nombreuses figures qui donneront tout son sens à
          votre apprentissage.
        </p>{" "}
        
        <p className=" text-2xl pw">
          La danse de salon est bien plus qu’une simple activité ; elle est
          sociale, artistique et sportive.{" "}
        </p>
      </section>


      <section className="my-28 -z-100">
          <div class="elfsight-app-8808101f-5c66-42a3-85ca-ca19e22c3747" data-elfsight-app-lazy></div>
      </section>
    </div>
  );
}
